import Vue from 'vue'
import VueRouter from 'vue-router'
import QuestionForm from './components/QuestionForm.vue'
import Helper from './components/Helper.vue'
import Payment from './components/Payment.vue'
import Payment2 from './components/Payment2.vue'
import ServiceIntro from './components/ServiceIntro.vue'
import ImageUpload from './components/ImageUpload.vue'
import UDEFeedback from './components/UDEFeedback.vue'
import Imgupload from './components/Imgupload.vue'
import PaymentConfirm from './components/PaymentConfirm.vue'
import UDEApp from './components/UDEApp.vue'
import UdeEvent from './components/UdeEvent.vue'
import UdeQuestionForm from './components/UdeQuestionForm.vue'
import QnA from './components/QnA.vue'
import Test from './components/Test.vue'
import SecondOpinion from './components/SecondOpinion.vue'
import EpsPi from './components/EpsPi.vue'
import Routes from './components/Routes.vue'
import PdfUpload from './components/PdfUpload.vue'
import ChatRoom from './components/ChatRoom.vue'
import QuestionnaireList from './components/QuestionnaireList.vue'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/questionform',
      name: 'questionform',
      component: QuestionForm
    },
    {
      path: '/helper',
      name: 'helper',
      component: Helper
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment
    },
    {
      path: '/payment2',
      name: 'payment2',
      component: Payment2
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/serviceintro',
      name: 'ServiceIntro',
      component: ServiceIntro
    },
    {
      path: '/imageupload',
      name: 'ImageUpload',
      component: ImageUpload
    },
    {
      path: '/udefeedback',
      name: 'udefeedback',
      component: UDEFeedback
    },
    {
      path: '/',
      name: 'imgupload',
      component: Imgupload
    },
    {
      path: '/paymentconfirm',
      name: 'paymentconfirm',
      component: PaymentConfirm
    },
    {
      path: '/udeapp',
      name: 'ude',
      component: UDEApp
    },
    {
      path: '/udeevent',
      name: 'udeevent',
      component: UdeEvent
    },
    {
      path: '/udequestionform',
      name: 'udecquestionform',
      component: UdeQuestionForm
    },
    {
      path: '/qna',
      name: 'qna',
      component: QnA
    },
    {
      path: '/secondopinion',
      name: 'secondopinion',
      component: SecondOpinion
    },
    {
      path: '/epspi',
      name: 'epspi',
      component: EpsPi
    },
    {
      path: '/routes',
      name: 'routes',
      component: Routes
    },
    {
      path: '/pdfupload',
      name: 'pdfupload',
      component: PdfUpload
    },
    {
      path: '/chatroom',
      name: 'chatroom',

      component: ChatRoom
    },
    {
      path: '/questionnairelist',
      name: 'questionnairelist',
      component: QuestionnaireList
    }
  ]
})